var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Tag__container"},_vm._l((_vm.content),function(tag){return _c('div',{key:tag,staticClass:"Tag",class:[_vm.theme]},[_vm._v(" "+_vm._s(tag)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }